import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../../content/siteContent";
import { ContactNumbers } from "../ContactNumbers/ContactNumbers";

export const FooterOne = () => {
  return (
    <footer>
      <div className="footer-area footer-bg">
        <div className="container">
          <div className="footer-top">
            <div className="row">
              <div className="col-lg-3 col-md-7">
                <div className="footer-widget">
                  <div className="fw-logo mb-4">
                    <Link to="/">
                      <img src="/images/logo/logo.png" alt={`${COMPANY.name} logo`} />
                    </Link>
                  </div>
                  <div className="footer-content">
                    <p>
                      Welcome to Zawix Business Consultants, a trusted name in
                      Pakistan since 2015. From company registration and tax
                      solutions to audit support, we offer expert services
                      tailored to your business needs.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Menu</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/services">Services</Link>
                      </li>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Quick Links</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <a href={COMPANY.emailHref}>Email Us</a>
                      </li>
                      <li>
                        <a href={COMPANY.whatsappHref}>Message on WhatsApp</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <h4 className="fw-title">Contact Details</h4>
                  <div className="footer-info">
                    <ul className="list-wrap">
                      <li>
                        <div className="icon">
                          <i className="flaticon-pin"></i>
                        </div>
                        <div className="content">
                          <p>
                            Office No. 206 2nd Floor,
                            <br />
                            Royal Centre Blue Area,
                            <br />
                            Islamabad, Pakistan
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="content">
                          <ContactNumbers className="footer-contact-numbers" />
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="flaticon-clock"></i>
                        </div>
                        <div className="content">
                          <p>
                            Monday - Friday: 9:00 AM - 6:00
                            <br />
                            PM
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="left-sider">
                  <div className="copyright-text">
                    <p>© 2025 Zawix Business Consultants. All rights reserved.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="footer-social">
                  <ul className="list-wrap">
                    <li>
                      <a
                        href={COMPANY.facebookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href={COMPANY.emailHref}>
                        <i className="flaticon-mail"></i>
                      </a>
                    </li>
                    <li>
                      <a href={COMPANY.whatsappHref}>
                        <i className="fab fa-whatsapp"></i>
                      </a>
                    </li>
                    <li>
                      <a href={COMPANY.phoneHref}>
                        <i className="flaticon-phone-call"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
